module.exports = __webpack_public_path__ + "static/media/advantages_1.7f085d51.svg";